import {useEffect, useState} from "react";

import {getProductDetails} from "../api/product-details";

const genQuery = (productGroupId, options) => {
    let product_type_id = '';
    if (productGroupId) {
        product_type_id = options.filter((item) => item.data.id === productGroupId)[0].data.product_type_id;
    }

    return `?group_id=${productGroupId}&product_type_id=${product_type_id}`;
}

function useProductDetails(productGroupId, productGroupHeadings) {
    const [loading, setLoading] = useState(false);
    const [productDetails, setProductDetails] = useState({});
    const url = window.SiteConfig.baseUrl;

    const loadProductItems = async (query) => {
        setLoading(true);
        const products = await getProductDetails(url.concat('/ajax/productsJson'), query);
        setProductDetails(products);
        setLoading(false);
    };

    useEffect(() => {
        let ignore = false;
        const queryParamsNew = genQuery(productGroupId, productGroupHeadings);
        if (!ignore) {
            loadProductItems(queryParamsNew);
        }

        return () => {
            ignore = true;
        }
    }, [productGroupId, productGroupHeadings]);

    return {
        productDetails,
        loadingProductDetails: loading,
    };
}

export default useProductDetails;